<div class="product-card">
  <div class="product-card__warenbereich">
    <span class="product-card__warenbereich-text">{{ entry.product.productGroup | productGroupTranslate }}</span>
  </div>

  <div class="product-card__media">
    <a class="product-card__media-link" [routerLink]="detailLink" [queryParams]="detailQueryParams" [attr.aria-label]="productName">
      <ng-container *ngIf="coverImage as img; else productImagePlaceholder">
        <img class="product-card__image" [src]="img" alt="" loading="lazy" (error)="onImageError()" />
      </ng-container>
      <ng-template #productImagePlaceholder>
        <span class="product-card__placeholder">
          <markant-icon class="product-card__placeholder-icon" icon="m_image" aria-hidden="true"></markant-icon>
          <span class="product-card__placeholder-text">Es wurde noch kein Produktbild hochgeladen.</span>
        </span>
      </ng-template>
    </a>
  </div>

  <a class="product-card__body" [routerLink]="detailLink" [queryParams]="detailQueryParams">
    <h3 class="product-card__name" [title]="productName">
      <span class="product-card__name-text">{{ productName }}</span>
    </h3>
    <p class="product-card__startup" [title]="startupName">{{ startupName }}</p>
  </a>

  <div class="product-card__widget" *ngIf="entryWidget">
    <ng-container *ngTemplateOutlet="entryWidget; context: widgetContext"></ng-container>
  </div>
</div>
